import type {
  PublicSegment,
  PublicSegmentV4,
  PublicTrip,
  PublicTripV4
} from "@busbud/core-types/dist/lib/poll-service/api";

import type { LegIndex } from "@app/constants/trip";
import { OUTBOUND_LEG_INDEX, RETURN_LEG_INDEX } from "@app/constants/trip";

import { getSegmentById } from "./get-segment-by-id";
import { getSegmentIdsPerLeg } from "./get-segment-ids-per-leg";
import { throwsIfAccessingReturnLegOfOnewayTrip } from "./leg-access-guard";

type LegOriginDestinationSegments = {
  origin_segment: PublicSegment | PublicSegmentV4;
  destination_segment: PublicSegment | PublicSegmentV4;
};

export function getOutboundLegOriginDestinationSegments(
  trip: PublicTrip | PublicTripV4
): LegOriginDestinationSegments {
  return getLegOriginDestinationSegments(trip, OUTBOUND_LEG_INDEX);
}

export function getReturnLegOriginDestinationSegments(
  trip: PublicTrip | PublicTripV4
): LegOriginDestinationSegments {
  return getLegOriginDestinationSegments(trip, RETURN_LEG_INDEX);
}

export function getLegOriginDestinationSegments(
  trip: PublicTrip | PublicTripV4,
  leg_index: LegIndex
): LegOriginDestinationSegments {
  throwsIfAccessingReturnLegOfOnewayTrip(trip, leg_index);

  const legsSegmentsIds = getSegmentIdsPerLeg(trip.trip_legs);
  const selectedLegSegmentIds = legsSegmentsIds[leg_index];
  // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const firstSegmentId = selectedLegSegmentIds[0];
  // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const lastSegmentId = selectedLegSegmentIds[selectedLegSegmentIds.length - 1];

  return {
    // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    origin_segment: getSegmentById(firstSegmentId, trip.segments),
    // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    destination_segment: getSegmentById(lastSegmentId, trip.segments)
  };
}
